import type { DataTableRowIdentification } from './row-identification-types.js';
import type { Row, TableOptions } from '../../hooks/useTable/types.js';
import type { DataTableRowData } from '../../public.api.js';

/**
 * Constant by which the row ids will be joined when using a custom row id
 * in combination with subrows.
 * @public
 */
export const DATA_TABLE_ROW_ID_SEPARATOR = '↳';

/**
 * Configuration hook for the rowInteractivity in the DataTable.
 * @internal
 */
export function useRowIdentification<TData extends DataTableRowData>(
  props: DataTableRowIdentification<TData>,
  options: TableOptions<TData>,
): void {
  const rowIdentificationFn = props.rowId;

  if (rowIdentificationFn) {
    options.rowIdSeparator = DATA_TABLE_ROW_ID_SEPARATOR;
    options.getRowId = (row: TData, _index: number, parent?: Row<TData>) => {
      const rowId = rowIdentificationFn(row);
      if (parent) {
        const parentId = parent.id;
        return `${parentId}${options.rowIdSeparator}${rowId}`;
      }
      return rowId;
    };
  } else {
    options.getRowId = undefined;
  }
}
